<!-- 24猎管理 -->
<template>
  <div class="pro_hunting" v-loading="loading">
    <div class="caozuo">
      <!-- <el-cascader v-model="value" :options="options" placeholder="公司名称" @change="handleChange"></el-cascader> -->
      <el-cascader
        v-model="place_value"
        :options="place_options"
        placeholder="公司所在地"
        :props="agent_props"
      ></el-cascader>
      <el-input
        v-model="agent_company_name__icontains"
        style="width: 200px"
        placeholder="公司名"
      ></el-input>
      <el-button type="primary" @click="sousuo">搜索</el-button>
      <el-button
        v-if="place_value.length != 0 || agent_company_name__icontains != ''"
        type="danger"
        @click="
          place_value = [];
          agent_company_name__icontains = '';
        "
        >清空</el-button
      >
    </div>

    <el-table
      :data="agentData"
      style="width: 100%"
      row-key="agent_id"
      :row-class-name="tableRowClassName"
      >>
      <el-table-column
        prop="username"
        label="用户名"
        width="180"
        v-if="
          $cookies.get('auth_grade') != 20 && $cookies.get('auth_grade') != 30
        "
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        width="180"
        v-if="
          $cookies.get('auth_grade') != 20 && $cookies.get('auth_grade') != 30
        "
      ></el-table-column>
      <el-table-column prop="realname" label="联系人"></el-table-column>
      <el-table-column
        prop="agent_company_name"
        label="公司名称"
      ></el-table-column>
      <el-table-column prop="address" label="公司所在地">
        <template slot-scope="scope">
          <div>
            {{ scope.row.agent_city_data.province_name }}-{{
              scope.row.agent_city_data.city_name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop label="是否省代">
        <template slot-scope="scope">
          <div>{{ scope.row.is_province_agent == 1 ? "是" : "否" }}</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="account_balance"
        label="充值余额"
      ></el-table-column>
      <el-table-column
        prop="create_time_str"
        label="创建时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        :width="$cookies.get('auth_grade') > 90 ? '320' : '240'"
        fixed="right"
        v-if="$cookies.get('auth_grade') >= 90"
      >
        <template slot-scope="scope">
          <el-button
            type="info"
            size="mini"
            v-if="
              $cookies.get('auth_grade') > 90 &&
              scope.row.is_province_agent == 0
            "
            @click="Rransfer(scope.row)"
            >转账</el-button
          >
          <el-button type="danger" size="mini" @click="Recharge(scope.row)"
            >充值</el-button
          >
          <el-button type="primary" size="mini" @click="RechargeJilu(scope.row)"
            >收支记录</el-button
          >
          <el-button type="warning" size="mini" @click="look_item(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right" v-else>
        <template slot-scope="scope">
          <!-- <el-button type="danger" size="mini" @click="Recharge(scope.row)">充值</el-button>
          <el-button type="primary" size="mini" @click="RechargeJilu(scope.row)">收支记录</el-button>-->
          <el-button type="warning" size="mini" @click="look_item(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="15"
        :total="total"
        :current-page="currPage"
        hide-on-single-page
        @current-change="pageChange"
      ></el-pagination>
    </div>
    <el-dialog
      title="充值"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="
        () => {
          dialogVisible = false;
        }
      "
    >
      <el-form ref="form" label-width="80px">
        <el-form-item label="充值金额">
          <el-input
            v-model="recharge"
            placeholder="请输入充值金额 (单位元)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false;
            recharge = '';
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="rechargeYes">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="转账"
      :visible.sync="is_transfer"
      width="30%"
      :before-close="
        () => {
          is_transfer = false;
        }
      "
    >
      <el-form ref="form" label-width="100px">
        <el-form-item label="转账省代公司">
          <el-select v-model="transfer_pro" placeholder="请选择">
            <el-option
              v-for="item in transfer_pro_data"
              :key="item.staff_id"
              :label="item.agent_company_name"
              :value="item.staff_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额">
          <el-input
            v-model="transfer"
            placeholder="请输入转账金额 (单位元)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            is_transfer = false;
            transfer_pro = '';
            transfer = '';
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="transferYes">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="收支记录"
      :visible.sync="isRechargeJilu"
      width="800px"
      :before-close="
        () => {
          isRechargeJilu = false;
        }
      "
    >
      <div v-loading="RechargeJiluLoading">
        <el-form ref="form" label-width="80px">
          <el-form-item label="筛选月份">
            <el-date-picker
              style="width: 200px"
              v-model="month"
              type="month"
              placeholder="筛选"
              @change="changeMouth"
              format="yyyy-MM"
              :clearable="false"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
          <div class="zhishouru">
            <span>提单</span>
            ￥{{ data.month_disburse_money }}
            &nbsp;
            <span>充值</span>
            ￥ {{ data.month_income_money }}
          </div>
        </el-form>
        <div class="foeeee">
          <el-table :data="data.detail" style="width: 100%">
            <el-table-column
              prop="agent_company_name"
              label="公司"
              max-width="180"
            >
              <template slot-scope="scope">
                <span :title="scope.row.agent_company_name">{{
                  scope.row.agent_company_name.length > 5
                    ? scope.row.agent_company_name
                    : scope.row.agent_company_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="credit" label="充值金额"></el-table-column>
            <el-table-column
              prop="deduction"
              label="结算金额"
            ></el-table-column>
            <el-table-column
              prop="deduction_cilent_name"
              label="结算公司"
              max-width="180"
            >
              <template slot-scope="scope">
                <span :title="scope.row.deduction_cilent_name">{{
                  scope.row.deduction_cilent_name.length > 5
                    ? scope.row.deduction_cilent_name
                    : scope.row.deduction_cilent_name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="时间"></el-table-column>
            <el-table-column
              prop="create_time"
              label="操作"
              v-if="$cookies.get('auth_grade') == 100"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteRechargeJilu(scope.row)"
                >
                  删除
                </el-button>
                <el-button
                  type="warning"
                  size="mini"
                  @click="editRechargeJilu(scope.row)"
                >
                  修改
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      agentData: [],
      place_value: [],
      agent_company_name__icontains: "",
      place_options: [],
      loading: true,
      agent_props: {
        label: "name",
        value: "id",
        children: "children",
      },
      total: 0,
      page: 0,
      currPage: 1,
      recharge: "",
      dialogVisible: false,
      agent_staff_id: "",
      isRechargeJilu: false,
      tableDataRechargeJilu: [],
      data: {
        account_balance: 0,
        all_redit_money: 0,
        detail: [],
        month_disburse_money: 0,
        month_income_moneyL: 0,
      },
      month: "",
      staff_id: "",
      transfer: "",
      is_transfer: false,
      transfer_pro: "",
      transfer_pro_data: [],
      transfer_agent: "", //转账人
      RechargeJiluLoading: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //修改收支记录结算金额
    editRechargeJilu(data) {
      this.$prompt("请输入修改的结算金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          require("post", "/lufish_user/v1/update_account_balance/", {
            deduction: value || 0,
            id: data.id,
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success("修改成功！");
              this.account_balance_list();
            }
          });
        })
        .catch(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_province_agent === 1) {
        return "warning-row";
      }
      return "success-row";
    },
    Rransfer(data) {
      this.transfer_agent = data.staff_id;
      this.is_transfer = true;
    },
    transferYes() {
      if (!this.transfer_pro) {
        this.$message.warning("请选择转账省代公司");
        return false;
      }
      console.log(/^[0-9]*$/.test(this.transfer));
      if (!/^[0-9]*$/.test(this.transfer)) {
        this.$message.warning("请输入转账金额 (单位元)");
        return false;
      }
      let obj = {
        agent_staff_id: this.transfer_pro,
        remittance: Number(this.transfer),
        remittance_agent_staff_id: this.transfer_agent,
      };
      require("post", "/lufish_user/v1/lufish_remittance/", obj).then((res) => {
        if (!res.code) {
          this.$message.success("转账成功！");
          this.is_transfer = false;
          this.transfer_pro = "";
          this.transfer = "";
          this.init();
        }
      });
    },
    sousuo() {
      this.currPage = 1;
      this.page = 0;
      this.$cookies.set("agentManagent_pro_page", 0);
      this.init();
    },
    look_item(data) {
      require("post", "/hr24_user/v1/search_user_info/", {
        search_data: {
          username: data.username,
        },
      }).then((res) => {
        if (!res.code) {
          this.$cookies.set("agent_username", data.username);
          this.$router.push({
            path: "/agentData",
            query: {
              id: data.username,
              is_proAgent: data.is_province_agent || 0,
            },
          });
        } else {
          this.$message.error("暂未开通24猎账号，请开通！");
        }
      });
    },
    agent_place() {
      require("post", "/lufish_user/v1/all_agent_city/", {}).then((res) => {
        this.place_options = res.data;
      });
    },
    pageChange(page) {
      this.page = page - 1;
      this.currPage = page;
      this.$cookies.set("agentManagent_pro_page", page - 1);
      console.log(this.$cookies.get("agentManagent_pro_page"));
      this.init(page - 1);
    },
    Recharge(data) {
      this.agent_staff_id = data.staff_id;
      this.dialogVisible = true;
    },
    rechargeYes() {
      var reg = /^[0-9]+.?[0-9]*$/;
      if (!(this.recharge && reg.test(this.recharge))) {
        this.$message.warning("请输入充值金额");
        return false;
      }
      let obj = {
        agent_staff_id: this.agent_staff_id,
        credit: this.recharge,
      };
      require("post", "/lufish_user/v1/lufish_agent_recharge/", obj).then(
        (res) => {
          if (!res.code) {
            this.$message.success("充值成功！");
            this.dialogVisible = false;
            this.recharge = "";
            this.init();
          }
        }
      );
    },
    RechargeJilu(data) {
      var date = new Date();
      let month = date.getMonth() + 1 + "";
      console.log(month); //获取当前月份(0-11,0代表1月) //获取完整的年份(4位)
      month = month.length == 1 ? "0" + month : month;
      this.month = date.getFullYear() + "-" + month;
      this.staff_id = data.staff_id;
      this.account_balance_list();
    },
    deleteRechargeJilu(row) {
      let obj = {
        id: row.id,
      };
      require("post", "/lufish_user/v1/delete_account_balance/", obj).then(
        (res) => {
          if (!res.code) {
            this.RechargeJiluLoading = true;
            this.account_balance_list();
            // this.data = res.data;
            // this.isRechargeJilu = true;
            // this.RechargeJiluLoading = false;
          }
        }
      );
    },
    account_balance_list() {
      this.RechargeJiluLoading = true;
      let obj = {
        year: this.month.substring(0, 4) || "",
        month: this.month.substring(5, this.month.length) || "",
        staff_id: this.staff_id,
      };
      require("post", "/lufish_user/v1/account_balance_list/", obj).then(
        (res) => {
          if (!res.code) {
            this.data = res.data;
            this.isRechargeJilu = true;
            this.RechargeJiluLoading = false;
          }
        }
      );
    },
    changeMouth() {
      this.account_balance_list();
    },
    init() {
      this.loading = true;
      let obj = {
        page: this.page,
        is_province_agent: 1,
        search_data: {},
      };

      if (this.place_value.length == 2) {
        obj.search_data.agent_city_id =
          this.place_value[this.place_value.length - 1];
      }
      if (this.agent_company_name__icontains) {
        obj.search_data.agent_company_name__icontains =
          this.agent_company_name__icontains;
      }
      require("post", "/lufish_user/v1/all_agent_list/", obj).then((res) => {
        if (!res.code) {
          this.agentData = res.data;
          this.transfer_pro_data = res.data;
          this.agentData.map((item, index) => {
            item.id = index + 1;
            if (item.children) {
              item.children.map((ele, i) => {
                ele.id = index + 1 + "" + (i + 1);
                return ele;
              });
            }

            return item;
          });
          this.total = res.agent_count;
          this.loading = false;
        }
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let page = Number(this.$cookies.get("agentManagent_pro_page"));
    console.log(page, !page);
    if (page) {
      this.currPage = page + 1;
      this.page = page;
      this.init();
    } else {
      this.init();
    }
    this.agent_place();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.pro_hunting {
  position: relative;
  top: 80px;
  left: 200px;
  width: calc(100% - 220px);
  /* background: rgb(253, 88, 88); */
  min-height: 80vh;
  margin-bottom: 50px;
}

.pro_hunting >>> el-table__row--level-1 {
  background-color: rgb(233, 240, 201);
}
.caozuo,
.page {
  padding: 12px 0;
}
.page {
  text-align: center;
}
.pro_hunting >>> .warning-row {
  background: oldlace;
}
.pro_hunting >>> .el-table .success-row {
  background: #f0f9eb;
}
.foeeee {
  max-height: 300px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/agentManagement/pro_hunting.vue